import React from "react";
import { Box, Typography, Button } from "../../ui-kit";
import { ONBOARDING_TEXT } from "../text.constants";
import { useStyles } from "./RejectedCard.styles";

export interface RejectedCardProps {
  label: string;
  fileName: string;
  thumbnailUrl?: string;
  /** Kept for callers that still track per-field reasons; the card itself no longer displays them (red border is sufficient). */
  reasons?: string[];
  className?: string;
  /** When provided, renders an inline "Undo" action that reverts just this field's rejection. */
  onUndo?: () => void;
}

const RejectedCard = ({ label, fileName, thumbnailUrl, reasons = [], className, onUndo }: RejectedCardProps) => {
  const classes = useStyles();
  return (
    <Box className={`${classes.root}${className ? ` ${className}` : ""}`}>
      <Typography className={classes.label}>{label}</Typography>
      <Box className={classes.card}>
        <Box className={classes.cardRow}>
          <Box className={classes.thumbnail}>
            {thumbnailUrl && <img src={thumbnailUrl} alt={label} />}
          </Box>
          <Typography className={classes.fileName}>{fileName}</Typography>
          {onUndo && (
            <Button size="small" className={classes.undoBtn} onClick={onUndo} disableRipple>
              {ONBOARDING_TEXT.DVP_UNDO_BTN}
            </Button>
          )}
        </Box>
        {reasons.length > 0 && (
          <Box className={classes.reasonsList}>
            <Typography className={classes.reasonsTitle}>{ONBOARDING_TEXT.RC_REASONS_TITLE}</Typography>
            {reasons.map((r) => (
              <Typography key={r} className={classes.reasonItem}>{r}</Typography>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default RejectedCard;
